import { useState, useEffect } from 'react';
import api from '../../utils/api';

function StatCard({ label, value, sub, color }) {
  return (
    <div style={{
      background: 'white', borderRadius: 12, padding: '20px 24px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.08)', flex: 1, minWidth: 160,
      borderTop: `3px solid ${color || '#6366f1'}`,
    }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: '#0f172a' }}>{value ?? '—'}</div>
      <div style={{ fontSize: 13, fontWeight: 600, color: '#64748b', marginTop: 4 }}>{label}</div>
      {sub && <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/admin/overview')
      .then(d => setData(d))
      .catch(e => setError(e.message || 'Yüklenemedi'))
      .finally(() => setLoading(false));
  }, []);

  const eventTypeLabel = (type) => {
    if (type === 'new_signup') return { label: 'Yeni Kayıt', color: '#10b981' };
    if (type === 'new_reservation') return { label: 'Rezervasyon', color: '#3b82f6' };
    return { label: type, color: '#94a3b8' };
  };

  if (loading) return <div style={{ padding: 40, color: '#64748b' }}>Yükleniyor...</div>;
  if (error) return <div style={{ padding: 40, color: '#ef4444' }}>Hata: {error}</div>;

  const SEVERITY_STYLE = {
    error:   { bg: '#fef2f2', border: '#fecaca', icon: '🔴', text: '#991b1b' },
    warning: { bg: '#fffbeb', border: '#fde68a', icon: '🟡', text: '#92400e' },
    info:    { bg: '#f0f9ff', border: '#bae6fd', icon: '🔵', text: '#0369a1' },
  };

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>Genel Bakış</h1>
      <p style={{ color: '#64748b', marginBottom: 20, fontSize: 14 }}>Platform geneli canlı veriler</p>

      {/* Uyarılar kutusu */}
      {data.alerts?.length > 0 ? (
        <div style={{ marginBottom: 24, borderRadius: 12, border: '1px solid #fde68a', background: '#fffbeb', padding: '14px 18px' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#92400e', marginBottom: 10 }}>⚠️ Aksiyon Gerektiren Durumlar</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {data.alerts.map((a, i) => {
              const s = SEVERITY_STYLE[a.severity] || SEVERITY_STYLE.info;
              return (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px',
                  borderRadius: 8, background: s.bg, border: `1px solid ${s.border}`,
                }}>
                  <span style={{ flexShrink: 0 }}>{s.icon}</span>
                  <span style={{ fontSize: 13, color: s.text }}>{a.message}</span>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div style={{ marginBottom: 24, borderRadius: 12, border: '1px solid #bbf7d0', background: '#f0fdf4', padding: '12px 18px', fontSize: 13, color: '#166534', fontWeight: 600 }}>
          ✅ Her şey yolunda — aksiyon gerektiren durum yok
        </div>
      )}

      {/* Stats */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 32 }}>
        <StatCard label="Toplam Otel" value={data.totalHotels} color="#6366f1" />
        <StatCard label="Aktif Denemeler" value={data.activeTrials} color="#f97316" sub="trial plan" />
        <StatCard label="Bugün Mesaj" value={data.todayMessages} color="#10b981" />
        <StatCard label="Bugün Rezervasyon" value={data.todayReservations} color="#3b82f6" />
        <StatCard
          label="Bugün AI Maliyeti"
          value={`$${(data.todayAiCost || 0).toFixed(4)}`}
          color="#8b5cf6"
        />
      </div>

      {/* Recent events */}
      <div style={{ background: 'white', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 16 }}>Son Aktiviteler</h2>
        {data.recentEvents?.length === 0 && (
          <div style={{ color: '#94a3b8', fontSize: 14 }}>Henüz aktivite yok.</div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {data.recentEvents?.map((ev, i) => {
            const { label, color } = eventTypeLabel(ev.type);
            return (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: 14,
                padding: '10px 14px', borderRadius: 8, background: '#f8fafc',
              }}>
                <span style={{
                  fontSize: 11, fontWeight: 700, padding: '2px 8px',
                  borderRadius: 20, background: color + '20', color,
                  whiteSpace: 'nowrap',
                }}>{label}</span>
                <span style={{ fontWeight: 600, fontSize: 14, color: '#1e293b', flex: 1 }}>
                  {ev.hotelName}
                </span>
                <span style={{ fontSize: 12, color: '#94a3b8', whiteSpace: 'nowrap' }}>
                  {new Date(ev.at).toLocaleString('tr-TR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
